import { SearchArcgisFeatureClassesApiRequest } from '../../../../types/requests/arcgis-feature-classes/search-arcgis-feature-classes.request';
import { useAxiosInfiniteQuery, useAxiosQuery } from './use-axios.hook';
import {
  getArcgisFeatureClass,
  getAttributesForArcgisFeatureClass,
  searchFeatureClasses,
} from '../../api/arcgis-civil3d-feature-classes.api';
import { ArcgisFeatureClassApiModel } from '../../../../types/models/arcgis-feature-class.model';
import { GetArcgisFeatureClassApiRequest } from '../../../../types/requests/arcgis-feature-classes/get-arcgis-feature-class.request';

const baseQueryKey = 'arcgis-feature-class';
const searchQueryKey = 'search';

export const useGetArcgisFeatureClass = <T extends ArcgisFeatureClassApiModel>(
  params: GetArcgisFeatureClassApiRequest,
) => {
  const { data, ...result } = useAxiosQuery<T>({
    queryKey: [baseQueryKey, params],
    queryFn: async () => (await getArcgisFeatureClass<T>(params)).data,
    enabled: Boolean(params.featureClassId && !Number.isNaN(params.featureClassId)),
  });
  return { ...result, arcgisFeatureClass: data } as const;
};

export const useGetAttributesForArcgisFeatureClass = (params: GetArcgisFeatureClassApiRequest) => {
  const { data, ...result } = useAxiosQuery({
    queryKey: [baseQueryKey, params],
    queryFn: async () => (await getAttributesForArcgisFeatureClass(params)).data,
    enabled: Boolean(params.featureClassId && !Number.isNaN(params.featureClassId)),
  });
  return { ...result, attributes: data } as const;
};

export const useSearchArcgisFeatureClasses = <T extends ArcgisFeatureClassApiModel>(
  params: SearchArcgisFeatureClassesApiRequest,
) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchFeatureClasses<T>({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
